import ApiService from "./ApiService";

/**
 * Service to handle request about users
 */
const UserService = {
  async getMe(): Promise<User> {
    return ApiService.get<User>("/users/me");
  },
  async getUsers(retrievesTraces = true): Promise<User[]> {
    return ApiService.get<User[]>("/users", { traces: retrievesTraces });
  },
  async updateUser(username: string, isLeader: boolean, isGPSEnabled: boolean): Promise<void> {
    return ApiService.put(`/users/${username}`, { isLeader, isGPSEnabled });
  },
  async createUser(label: string, password: string, companyId: string, role: UserRole) {
    return ApiService.post<User>("/users", { label, password, companyId, role });
  },
  async deleteUser(id: number): Promise<void> {
    return ApiService.delete(`/users/${id}`);
  },
  async updateUserConfig(username: string, config: UpdateUserConfigDTO): Promise<UserConfigDTO> {
    return ApiService.put<UserConfigDTO>(`/users/${username}/config`, config);
  },
  async updateUserPermissions(username: string, permissions: FeaturePermission[]): Promise<User> {
    return ApiService.put<User>(`/users/${username}/permissions`, { permissions });
  },
  async changeUserCompany(username: string, companyId: string): Promise<User> {
    return ApiService.put<User>(`/users/${username}/${companyId}`);
  },
};

export default UserService;
